import { RouteObject, Navigate } from 'react-router-dom';

export const inventoryRoutes: RouteObject[] = [
  {
    path: '',
    element: <Navigate to="/operations/products" replace />,
  },
  {
    path: 'products',
    element: <Navigate to="/operations/products" replace />,
    handle: { crumb: 'Stock Balances' },
  },
  {
    path: 'field-service',
    element: <Navigate to="/operations/service-orders" replace />,
    handle: { crumb: 'Field Dispatch' },
  },
  {
    path: 'warehouses',
    element: <Navigate to="/operations/warehouses" replace />,
    handle: { crumb: 'Warehouses' },
  },
  {
    path: 'movements',
    element: <Navigate to="/operations/transfers" replace />,
    handle: { crumb: 'Movements' },
  },
  {
    path: '*',
    element: <Navigate to="/operations/products" replace />,
  },
];

export default inventoryRoutes;
